import React from "react";
import logo from "../Assets/logo.png";
import "../Styles/Header.css";

function Header({ showHideMenu }) {
  return (
    <>
      <div className="header">
        <div className="header_container">
          <div data-aos="fade-right" className="logo_container">
            <img src={logo} alt="Logo" />
          </div>
          <div className="element_container">
            <div data-aos="fade-down" className="single_element">
              <a href="tel:9873691307">
                <h4 className="element_text">
                  <i class="fa-solid fa-phone"></i> (+91) 9873691307
                </h4>
                <span>Contact PyLoan</span>
              </a>
            </div>
          </div>
          <div className="element_container">
            <div data-aos="fade-left" className="single_element">
              <a href="mailto:Mudraloanhelp0@gmail.com">
                <h4 className="element_text">
                  <i className="fa-solid fa-envelope"></i>{" "}
                  Mudraloanhelp0@gmail.com
                </h4>
                <span>Email PyLoan</span>
              </a>
            </div>
          </div>
          <div className="menu_icon">
            <i
              className="fa-solid fa-bars-staggered hamburger"
              onClick={showHideMenu}
            ></i>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
